 <template>
    <v-card :height="height" class="support-card ma-1 d-flex flex-column" :loading="isFetching">
        <v-card-title class="d-flex flex-nowrap pa-5 pb-0">
            <p class="text-truncate" style="cursor: pointer" @click="onShowSocial">Соцзащита в ГИС ЖКХ</p>
            <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text class="pa-5 pt-0">
            <v-row no-gutters class="pb-0">
                <v-col cols="5" class="my-auto">
                    <span class="font-weight-medium greyBold--text" style="font-size: 24px;">{{cnt_new}}</span>
                    <p class="greyBold--text mb-0">Новые запросы</p>
                </v-col>
                <v-col cols="6">
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-col class="text-right">
                <v-btn
                    class=""
                    color="success"
                    text
                    @click="onShowSocial"
                >
                    <v-icon size="45">mdi-eye-outline</v-icon>
                </v-btn>
            </v-col>
        </v-card-actions>
    </v-card>
</template>

<script>
import { socialWidget } from '@/api/organizations';
import { mapGetters} from 'vuex';
export default {
    name: 'SocialWidget',
    components: {},
    props: {
        height: {
            default: 'auto'
        }
    },
    data: () => ({
        cnt_new: '-',
        isFetching: false
    }),
    created () {
        this.load();
    },
    methods: {
        onShowSocial(){
            this.$router.push({name: 'Social'});
        },
        async load(){
            try{
                this.cnt_new = '-';
                this.isFetching = true;
                let res = await socialWidget(this.ID_WORK_SPACE, this.ORGANIZATION_ID);
                this.cnt_new = res.data.cnt_new;
            }finally{
                this.isFetching = false;
            }
        }
    },
    watch:{
        ORGANIZATION_ID: function(newValue, oldValue){
            if(newValue != oldValue){
                this.load();
            }
        }
    },
    computed:{
        ...mapGetters('workspace', ['ORGANIZATION_ID', 'ID_WORK_SPACE'])
    },
}
</script>